<template>
  <mdb-container style="margin-top: 6em">
    <section class="text-justify text-monospace my-5">
      <h2 class="h1-responsive font-weight-bold my-5 text-center">希腊25万欧元购房移民</h2>
      <p class="w-responsive mx-auto mb-5">
        <span class="mr-4"></span>
        2013年4月，希腊政府出台了旨在促进本国经济发展的投资移民政策。2015年7月9日，希腊又通过了新的移民法案。非欧盟公民在希腊购买25万欧元以上的房子，主申请人、配偶、21周岁以下子女、配偶的父母均可一同申请获得永居。时下，希腊凭借其高性价比的优势，成为了欧洲移民圈的新宠。
      </p>
      <mdb-row class="">
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/gr/3.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请要求</h4>
            <p>1、主申请人年满18周岁</p>
            <p>2、在希腊购买25万欧元以上的房产</p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/gr/1.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">项目优势</h4>
            <p>1、投资金额少：仅需25万欧元购房，一步到位获得绿卡</p>
            <p>2、申请条件低：无需体检、面试、无语言要求、无商业背景要求、无需解释资金来源</p>
            <p>3、获得身份快：递交材料后最快两个月获批，拿申根国永居身份</p>
            <p>4、居住要求无：无需在希腊居住，不影响国内工作及生活</p>
            <p>5、身份价值高：一人投资、三代移民，通行欧盟与申根国</p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/gr/5.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请流程</h4>
            <p>1、与嘉诚海外签约</p>
            <p>2、到希腊进行房产考察或国内VR看房</p>
            <p>3、支付房款</p>
            <p>4、递交移民材料</p>
            <p>5、录取指纹</p>
            <p>6、等待获批</p>
            <p>7、获得希腊永居</p>

          </mdb-card-body>
        </mdb-col>
      </mdb-row>
    </section>
  </mdb-container>
</template>

<script>
  export default {
    name: 'Gr'
  }
</script>

<style scoped>

</style>
